/** @file Deletes a skin that is not the default; attachments only it mapped go with it. */
import { defineRemove } from '../_shared/defineRemove';

/** skin.delete: the defineRemove factory (removeEntity refuses the default skin and drops orphaned attachments). */
export const command = defineRemove({
  domain: 'skin',
  kind: 'skin',
  description: 'Delete a skin (never the default skin: run skin.setDefault first); attachments that only this skin mapped are deleted too (a warning counts them).',
});
